"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AnyDataTypeImpl = /** @class */ (function () {
    function AnyDataTypeImpl() {
        /**
         * The constructor function creating the value type
         */
        this.valueClass = AnyDataTypeImpl;
    }
    /**
     * @inheritdoc
     */
    AnyDataTypeImpl.prototype.name = function () {
        return 'any';
    };
    return AnyDataTypeImpl;
}());
exports.AnyDataTypeImpl = AnyDataTypeImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/data/any-datatype.js
// module id = 258
// module chunks = 1